import { observer } from "mobx-react";
import PhoneNumber from "Models/PhoneNumber";
import TaxiCardListItem from "Models/TaxiCardListItem";

import TextBox from "Pages/CommonControls/TextBox";

export interface INameColumnProps {
    record: TaxiCardListItem;
    isUnderEdit: boolean;
}

function NameColumn(props: INameColumnProps) {

    return (
        <>
            {props.isUnderEdit ?
                <TextBox value={props.record.ownerName} onChange={props.record.setOwnerName} maxLength={64} /> :
                <span>{props.record.ownerName}</span>
            }
        </>
    )
}

export default observer(NameColumn);